import {Box, Button, ModalBody, ModalCloseButton, ModalContent, useDisclosure} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Modal} from 'components/shared';
import {TypeFilters} from 'components/shared/filters-modal/components';
import {IFilterType} from 'hooks';
import {useRouter} from 'next/router';
import {FC, PropsWithChildren, useState} from 'react';
import {modalCloseButtonStyles} from 'theme';
import {TranslationKeys} from 'translations';
import {FilterListTypes} from 'types';

import {OptionsButtonsGroup} from '..';

interface IProps {
  activeQueryParams?: IFilterType;
  onChange: (ordering: IFilterType) => void;
  t: (term: TranslationKeys) => string;
  title: string;
  typeList: {
    name: {en: string; ru: string; ro: string};
    label: string;
  }[];
}

export const OrderingModal: FC<PropsWithChildren<IProps>> = ({
  activeQueryParams,
  onChange,
  typeList,
  t,
  title,
  children,
}) => {
  const {onClose, isOpen, onOpen} = useDisclosure();
  const {query} = useRouter();
  const [tempOrdering, setTempOrdering] = useState(`${activeQueryParams?.ordering}`);

  const onOrderingActive = (value: FilterListTypes) => {
    if (value !== tempOrdering) {
      setTempOrdering(value);
    }
  };

  const resetOrdering = () => {
    onChange({
      ordering: undefined,
    });
    onClose();
  };

  const handleSubmit = () => {
    onChange({
      ordering: tempOrdering,
    });
    onClose();
  };

  return (
    <>
      <Box onClick={onOpen}>{children}</Box>
      <Modal onClose={onClose} isOpen={isOpen}>
        <ModalContent maxW={['90%', '900px']} bg={colors.bodyBackground} overflow="hidden" mt="5vh">
          <ModalCloseButton mt="15px" sx={modalCloseButtonStyles} />
          <ModalBody p={0}>
            <TypeFilters onChange={onOrderingActive} filtersList={tempOrdering} typeList={typeList} title={title} />
            <Box w="full" boxShadow="0px -1px 4px rgba(0, 0, 0, 0.1)" p="16px" bg="white">
              {query.ordering ? (
                <OptionsButtonsGroup handleSubmit={handleSubmit} resetOrdering={resetOrdering} t={t} />
              ) : (
                <Button variant="primary" w="100%" onClick={handleSubmit}>
                  {t('APPLY')}
                </Button>
              )}
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
